import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { reset, setUsers, setLoading } from './actions';

const usersReducer = handleActions(
  {
    [setUsers.toString()]: (_, { payload: deletedUsers }) => deletedUsers,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  users: usersReducer,
  loading: loadingReducer
});
